<template>
  <div
    v-if="lineId"
    class="container"
  >
    <Toolbar class="mt-2 mb-2">
      <template #start>
        <h2>{{ $t("nav.lineIdDetail") }}</h2>
      </template>
    </Toolbar>

    <line-id-detail
      :line-id="lineId"
    />

    <Toolbar class="mt-2 mb-2">
      <template #start>
        <h2>{{ $t("lineidpage.associationsHistory") }}</h2>
      </template>
      <template #end>
        <Button
          v-if="isAdmin"
          :label="$t('action.crud.create')"
          icon="pi pi-plus"
          class="mr-2 p-button-outlined p-button-rounded"
          @click="showCreateForm = true"
        />
      </template>
    </Toolbar>
    <ControlTable
      v-model:rows="controlFilter.pageable.size"
      v-model:filters="controlFilter.filters"
      v-model:sortField="controlFilter.pageable.sortField"
      v-model:sortOrder="controlFilter.pageable.sortOrder"
      paginator-position="both"
      :paginator="true"
      :value="controls"
      :total-records="totalControlCount"
      @filter="getControls"
      @sort="getControls"
      @page="onPageChange($event)"
    />

    <BarcodeAddToLineIdDialog
      v-model:visible="showCreateForm"
      :line-id="lineId"
      @create="getControls"
    />
  </div>
</template>

<script>
import Toolbar from "primevue/toolbar";
import Button from "primevue/button";
import BarcodeAddToLineIdDialog from "@/components/barcodes/BarcodeAddToLineIdDialog.vue";
import ControlTable from "@/components/control/ControlTable.vue";
import LineIdDetail from "@/components/lineId/LineIdDetail";
import useControlFilter from "@/composables/filters/useControlFilter";
import {reactive} from "vue";

export default {
  name: 'LineIdView',
  components: {BarcodeAddToLineIdDialog, LineIdDetail, Toolbar, Button, ControlTable},
  setup() {
    const controlFilter = reactive(useControlFilter());
    controlFilter.pageable.sortField = "barcodeRange.start";
    controlFilter.filters.deleted.value = false;

    return {
      controlFilter
    };
  },
  data() {
    return {
      lineId: null,
      totalControlCount: 0,

      showCreateForm: false,
      controls: [],
      currentControl: null,
      showDetailAssoDialog: false
    }
  },
  computed: {
    isAdmin() {
      return this.$store.getters["auth/userIsAdmin"];
    }
  },
  async mounted() {
    const id = this.$route.params.id;
    await this.fetchLineId(id);
    await this.getControls();
  },
  methods: {
    async fetchLineId(id) {
      try {
        this.lineId = await this.$lineIdService.fetchLineId(id);
        this.controlFilter.filters.lineId.value = this.lineId.id;
      } catch (e) {
        console.error(e);
        await this.$router.push("/");
      }
    },
    async getControls() {
      const result = await this.$controlService.getAll(this.controlFilter.getQueryParams());
      this.controls = result.content;
      this.totalControlCount = result.totalElements;
    },
    onPageChange(event) {
      this.controlFilter.pageable.page = event.page;
      this.getControls();
    },
  }
}
</script>
